module.exports = __webpack_public_path__ + "img/Emergency Care 2.6115b850.png";